import { jsx } from "react/jsx-runtime";
import { ResponsiveIframe } from "@zillow/zrs-cms";
import { omit } from "lodash";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
const BlockYoutube = ({
  attrs
}) => {
  const {
    width = 1024,
    height = 768,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    url,
    videoId,
    autoplay = 0,
    muted = 0,
    controls = 1,
    loop = 0,
    color,
    fs = 1,
    modestbranding,
    noCookieDomain,
    loading = "lazy",
    title = "YouTube video player",
    ...iframeAttributes
  } = attrs;
  const domain = noCookieDomain ? "www.youtube-nocookie.com" : "www.youtube.com";
  const embedUrl = new URL(`https://${domain}/embed/${videoId}`);
  embedUrl.searchParams.append("autoplay", autoplay);
  embedUrl.searchParams.append("mute", muted);
  embedUrl.searchParams.append("loop", loop);
  embedUrl.searchParams.append("controls", controls);
  embedUrl.searchParams.append("color", color);
  embedUrl.searchParams.append("modestbranding", modestbranding ? 1 : 0);
  embedUrl.searchParams.append("fs", fs);
  if (color) {
    embedUrl.searchParams.append("color", color);
  }
  if (modestbranding) {
    embedUrl.searchParams.append("modestbranding", modestbranding);
  }
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsx(ResponsiveIframe, { src: embedUrl.href, title, allowFullScreen: fs, loading, width, height, ...omit(iframeAttributes, "margin"), ...isPost ? {
    marginBottom: "md"
  } : iframeAttributes.margin });
};
BlockYoutube.propTypes = {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    videoId: PropTypes.string,
    autoplay: PropTypes.bool,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    color: PropTypes.string,
    fs: PropTypes.bool,
    modestbranding: PropTypes.bool,
    noCookieDomain: PropTypes.bool,
    loading: PropTypes.string,
    title: PropTypes.string
  }),
  index: PropTypes.number
};
export {
  BlockYoutube as default
};
